"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardSummaryQuerySchema = void 0;
const zod_1 = require("zod");
/**
 * `GET /dashboard/summary` (task-8d-brief.md §1 / ruling R29) — `companyId`
 * is the only input, and it is mandatory: unlike every list endpoint's
 * `companyId` (which the frontend always sends anyway), the dashboard has no
 * sensible "all companies" answer, so this is enforced at the schema level
 * rather than left to the service to reject.
 */
exports.dashboardSummaryQuerySchema = zod_1.z.object({
    companyId: zod_1.z.uuid('companyId este obligatoriu și trebuie să fie un UUID valid.'),
});
